export default __webpack_public_path__ + "static/media/NewRelic.71e334b5.svg";